<template>
  <div class="ly-table">
    <div class="ly-title" v-if="!$isMobile()">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content" v-if="!$isMobile()">
      <el-form label-width="50%">
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblAdminName')"
              >{{ resData.admrNm }}
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblJobPosition')"
              >{{ resData.ofpos }}
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblDepartment')">
              {{ resData.dept }}</el-form-item
            >
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblPhoneNumber')"
              >{{ resData.telNo }}
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblCellPhone')"
              >{{ resData.ptblTel }}
            </el-form-item>
          </el-col>
          <el-col :span="8" :xs="24">
            <el-form-item :label="$t('messages.lblFax')">{{
              resData.fax
            }}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" :xs="24">
            <el-form-item
              :label="$t('messages.lblEmail')"
              :label-width="labelWidth"
              >{{ resData.email }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-divider class="wrk-comp-divider" v-if="!toggleData && !$isMobile()"></el-divider>
  </div>
</template>

<script>
export default {
  props: {
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      labelWidth: 100 / 6 + "%",
      resData: {},
    };
  },
  methods: {
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    async getWrkOderAdmrInfo() {
      if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
        const data = await this.$BIZ_SERVICE
          .post(this.scrnGetApi, {
            prcssTrtDataCnctId : this.prcssTrtDataCnctId
          })
        if (data.data.resData) {
          this.resData = data.data.resData;
          console.log("oder register : " + this.resData);
        }
      }else{
        if(this.defaultValue && Object.keys(this.defaultValue).length > 0 && this.isWrite){
          this.resData = this.defaultValue;
        }
      }
    },
    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.resData;
    },
    chkValidateData() {
      return true;
    },
  },
  mounted() {
    if (this.$isMobile()) {
      this.labelWidthL = this.labelWidth;
    }
    this.getWrkOderAdmrInfo();
  },
  watch: {
    prcssTrtDataCnctId() {
      this.getWrkOderAdmrInfo();
    },
  },
};
</script>
